module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_3.b244772e.png";